
import {
  defaultItem,
  defaultValues,
} from '@/components/crud/CrudMethodsV1.js';


export default {
  
  mixins:[],
  props: ['items','min','view_only','merge_item'],
  data() {
    return {
      list:[],
      defaultValues,
      selected_item:{},
      dialog:false,
    };
  },
  computed: {

  },
  watch: {
    items(v){
      if (Array.isArray(v)) this.list = this.items;
    }
  },
  created() {
    if (Array.isArray(this.items)) this.list = this.items;
    if (this.list.length === 0 && this.min === 1) this.add();
  },
  methods: {
    new_item:defaultItem,
    add(){
      this.selectedItem = this.new_item();
      this.list.push(this.selectedItem);
      this.$emit('update:items', this.list );
      if (this.post_new_item) this.requests.post[this.post_new_item](this.merge_item)
        .then(r=>Object.assign(this.selectedItem,r) || r);
    },
    select_to_remove(item){
      this.selected_item = item;
      this.dialog = true;
    },
    remove(item){
      this.dialog = false;
      this.list.splice(this.list.indexOf(item), 1);
      this.$emit('update:items', this.list );
      if (this.patch_remove_item) this.requests.patch[this.patch_remove_item]({id:item.id});
    }
  }, // methods
};
